import React from 'react';
import { LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { PriceDisplay } from './PriceDisplay';
import { Countdown } from './Countdown';
import { PaymentLogos } from './PaymentLogos';
import { PRICES, offerChips, productPillars, priceFraming, IMAGES } from '../data/content';
export function ProductOffer() {
  return <section id="oferta" className="w-full bg-cream px-5 py-14 sm:px-8 sm:py-20" data-id="element-134" data-mp="yi0zqe65l4ey">
      <div className="mx-auto max-w-3xl" data-id="element-135" data-mp="yfwn97u6ux32">
        <h2 className="text-center font-display text-3xl font-black tracking-tight text-plum sm:text-4xl" data-id="element-136" data-mp="138zfncn8c0ho">
          DesbloqueARTE
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-center font-sans text-base leading-relaxed text-plum-soft" data-id="element-137" data-mp="pj5qsubq5g7y">
          La Guía Más Completa del Método{' '}
          <strong className="font-bold text-plum" data-id="element-138" data-mp="fivedbxikctu">SOLTÁ · CREÁ · ACTUÁ</strong> para dejar de
          procrastinar
        </p>
        <div className="mt-8 overflow-hidden rounded-2xl border border-plum/10 shadow-lg" data-id="element-139" data-mp="khq6j4hdfdqm">
          <img src={IMAGES.mockup} alt="Mockup de la guía DesbloqueARTE en celular, tablet y versión impresa" className="h-full w-full object-cover" loading="lazy" data-id="element-140" data-mp="3ldrqbpwm8tao" />
        </div>
        <p className="mt-6 text-center font-display text-lg italic leading-snug text-plum sm:text-xl" data-id="element-141" data-mp="3udeu2ictib6w">
          "Si querés terminar lo que empezás, de forma rápida y sin depender de tu 'fuerza de
          voluntad', esta es la herramienta definitiva."
        </p>
        <div className="mt-8 grid gap-4 sm:grid-cols-3" data-id="element-142" data-mp="2xr1td2z4jowx">
          {productPillars.map(pillar => <article key={pillar.title} className="rounded-2xl border border-plum/10 bg-cream-deep p-5" data-id="element-143" data-mp="3bigbl7l7jm2x">
              <span className="text-2xl" aria-hidden="true" data-id="element-144" data-mp="2j0cglw60m1qy">
                {pillar.emoji}
              </span>
              <h3 className="mt-2 font-display text-base font-bold leading-snug text-plum" data-id="element-145" data-mp="2ezio0phmnyrq">
                {pillar.title}
              </h3>
              <p className="mt-2 font-sans text-sm leading-relaxed text-plum-soft" data-id="element-146" data-mp="hy33wriphxa8">
                {pillar.description}
              </p>
            </article>)}
        </div>

        {/* CAJA DE PRECIO */}
        <div className="mt-10 rounded-2xl bg-plum-deep p-6 text-center text-cream sm:p-8" data-id="element-147" data-mp="rq94gpn0xn11">
          <ul className="flex flex-wrap justify-center gap-2" data-id="element-148" data-mp="wpc0jkl10iwv">
            {offerChips.map(chip => <li key={chip} className="rounded-full border border-cream/15 bg-plum px-3 py-1.5 font-sans text-[11px] font-semibold uppercase tracking-wider text-cream/80" data-id="element-149" data-mp="3v6zergpn2m8j">
                {chip}
              </li>)}
          </ul>
          <p className="mt-7 font-sans text-xs uppercase tracking-[0.16em] text-cream/60" data-id="element-150" data-mp="duonhzquvew9">
            Precio real:{' '}
            <span className="line-through" data-id="element-151" data-mp="1pbwsam5eyx0y">
              <PriceDisplay amount={PRICES.real} data-id="element-152" data-mp="1pavck4dgdmcw" />
            </span>
          </p>
          <p className="mt-3 font-sans text-xs font-bold uppercase tracking-[0.2em] text-gold" data-id="element-153" data-mp="39u8ne743hivk">
            Solo por hoy
          </p>
          <p className="font-display text-5xl font-black leading-none sm:text-6xl" data-id="element-154" data-mp="34ve4l564nubg">
            <PriceDisplay amount={PRICES.today} showCode data-id="element-155" data-mp="302usydr0399a" />
          </p>
          <p className="mt-3 font-sans text-xs uppercase tracking-[0.14em] text-cream/60" data-id="element-156" data-mp="2v5kxohgxk3dj">
            Pago único · Sin cargos mensuales
          </p>
          <p className="mx-auto mt-6 max-w-sm border-t border-cream/15 pt-5 font-sans text-sm leading-relaxed text-cream/70" data-id="element-157" data-mp="2q7axttk9gell">
            {priceFraming.comparisonLong}
          </p>
        </div>

        {/* CONTADOR */}
        <div className="mt-6 rounded-2xl border-2 border-gold bg-gold/10 p-6 text-center" data-id="element-158" data-mp="2c66y9k0fm0fn">
          <p className="inline-flex items-center gap-2 font-sans text-sm font-black uppercase tracking-[0.14em] text-terracotta-dark" data-id="element-159" data-mp="2c8jr4s7q9v7h">
            <ZapIcon className="h-4 w-4" aria-hidden="true" data-id="element-160" data-mp="aekf24ms79tq" />
            Oferta solo por hoy
            <ZapIcon className="h-4 w-4" aria-hidden="true" data-id="element-161" data-mp="346aemzbnnj5m" />
          </p>
          <p className="mx-auto mt-2 max-w-md font-sans text-sm leading-relaxed text-plum-soft" data-id="element-162" data-mp="388f2tijc3nkv">
            Al llegar a cero, el precio vuelve a{' '}
            <PriceDisplay amount={PRICES.real} className="font-bold text-plum" data-id="element-163" data-mp="2u7ul6pp5nxsy" /> y los 3 bonos
            dejan de estar incluidos.
          </p>
          <p className="mt-5 font-sans text-xs font-bold uppercase tracking-[0.16em] text-plum" data-id="element-164" data-mp="2kiuiowbg2ka0">
            La oferta se termina en:
          </p>
          <div className="mt-3" data-id="element-165" data-mp="2pacl7ot48sx3">
            <Countdown data-id="element-166" data-mp="2pbnozomka0o7" />
          </div>
        </div>

        <div className="mt-7 flex justify-center" data-id="element-167" data-mp="2bj7gw9eszcgf">
          <CTAButton size="lg" className="w-full" data-id="element-168" data-mp="2bgbjqnas4rt1">
            Quiero mi guía
          </CTAButton>
        </div>
        <p className="mt-3 text-center font-sans text-xs font-semibold uppercase tracking-[0.12em] text-plum-soft" data-id="element-169" data-mp="21jyt5yaj6u2i">
          Pago único · Acceso inmediato
        </p>
        <div className="mt-5" data-id="element-170" data-mp="26i9xxulyyedv">
          <p className="text-center font-sans text-xs font-semibold text-plum-soft" data-id="element-171" data-mp="1mx00y13unvmq">
            🔒 Pago seguro y garantizado
          </p>
          <div className="mt-3" data-id="element-172" data-mp="1iwznaiokrogq">
            <PaymentLogos data-id="element-173" data-mp="1ixrab543wdve" />
          </div>
        </div>
        <div className="mx-auto mt-6 flex max-w-md flex-wrap items-center justify-center gap-x-5 gap-y-2 rounded-2xl border border-plum/10 bg-cream-deep px-5 py-4 text-plum-soft" data-id="element-174" data-mp="1wwh3warpvvf0">
          <span className="inline-flex items-center gap-1.5 font-sans text-xs font-semibold uppercase tracking-wider" data-id="element-175" data-mp="25vm0vcnmrgp2">
            <LockIcon className="h-4 w-4" aria-hidden="true" data-id="element-176" data-mp="21thduwrotibe" /> Checkout seguro
          </span>
          <span className="inline-flex items-center gap-1.5 font-sans text-xs font-semibold uppercase tracking-wider" data-id="element-177" data-mp="2fkvu4vu7n5er">
            <ShieldCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-178" data-mp="2andww2pk2eml" /> Garantía 7 días
          </span>
        </div>
      </div>
    </section>;
}